<template>
  <div class="home">
    <Eid />
    <h1>كل عام وأنتم بخير</h1>
    <AppForm />
  </div>
</template>

<script>
// @ is an alias to /src
import Eid from '@/components/Eid.vue'
import AppForm from '@/components/Form.vue'

export default {
  name: 'home',
  components: {
    Eid,
    AppForm
  }
}
</script>

<style lang="sass">

.home
  position: relative
  height: 100vh
  overflow-y: scroll

  &::-webkit-scrollbar
        width: 3px

  /* Track */
  &::-webkit-scrollbar-track
      background: #f1f1f1
      border-radius: 5px

  /* Handle */
  &::-webkit-scrollbar-thumb
      background: #f39c12
      border-radius: 5px

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover
      background: #f39c12
  
</style>
